import type { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import type { INoRowsOverlayParams } from 'ag-grid-community';
import { Component, signal } from '@angular/core';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';
import { LoadersModule } from "@app/app/components/loaders/loaders.module";

@Component({
  standalone: true,
  templateUrl: './no-notifications-overlay.component.html',
  imports: [ LoadersModule ],
  animations: [
    trigger('fadeIn', [
      transition(':enter', useAnimation(fadeIn, { params: { timing: 0.5 } }))
    ]),
  ],
})
export class NoNotificationsOverlayComponent implements INoRowsOverlayAngularComp {
  public params!: INoRowsOverlayParams;
  public noNotificationsMatchFilters = signal<boolean>(false);
  public filtersChecked = signal<boolean>(false);
  public waitedForDispatch = signal<boolean>(false);

  agInit(params: INoRowsOverlayParams): void {
    const filterModelKeys = Object.keys(params.api.getFilterModel());
    const quickFilter = params.api.getQuickFilter();
    if (filterModelKeys.length > 0 || quickFilter) {
      this.noNotificationsMatchFilters.set(true);
    }
    this.filtersChecked.set(true);
    this.refresh(params);
    setTimeout(() => this.waitedForDispatch.set(true), 2000);
  }

  refresh(params: INoRowsOverlayParams): void {
    this.params = params;
  }
}
